function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  id: "unpinArtifactVersion_svg__a",
  x1: -661.467,
  y1: 79.952,
  x2: -663.912,
  y2: 81.732,
  gradientTransform: "matrix(6.4 0 0 -4.4 4302.9 418.6)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.001,
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1
})), React.createElement("style", null, ".unpinArtifactVersion_svg__a{fill:#e8f4fa}.unpinArtifactVersion_svg__d,.unpinArtifactVersion_svg__m{fill:none;stroke-linecap:round}.unpinArtifactVersion_svg__d{stroke:#191816;stroke-linejoin:round}.unpinArtifactVersion_svg__m{stroke:#000}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "unpinArtifactVersion_svg__a",
  cx: 50,
  cy: 50,
  r: 39
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M69.8 39.1A9.832 9.832 0 0054.2 29a19.92 19.92 0 00-28-2.2 20.148 20.148 0 00-7 15v.1a4.869 4.869 0 00-1.2-.1 9.9 9.9 0 000 19.8h44.6A12.398 12.398 0 0075 49.2v-.1a12.643 12.643 0 00-5.2-10z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "unpinArtifactVersion_svg__a",
  d: "M62.6 55.2H17.9a10.013 10.013 0 01-9.4-6.7 8.591 8.591 0 00-.5 3.2 9.968 9.968 0 009.8 9.9h44.8A12.398 12.398 0 0075 49.2a11.235 11.235 0 00-.4-3.2 12.512 12.512 0 01-12 9.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "unpinArtifactVersion_svg__d",
  d: "M69.8 39.1A9.832 9.832 0 0054.2 29a19.92 19.92 0 00-28-2.2 20.148 20.148 0 00-7 15v.1a4.869 4.869 0 00-1.2-.1 9.9 9.9 0 000 19.8h44.6A12.398 12.398 0 0075 49.2v-.1a12.643 12.643 0 00-5.2-10z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#aa8d72",
  d: "M14.1 58.1l2.3-10.4 22.7-6.2 7.7 7.9-32.7 8.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2 57.6l30.3-8.3a1.284 1.284 0 011.6.9l6 22a1.284 1.284 0 01-.9 1.6L21.9 82a1.284 1.284 0 01-1.6-.9l-6-22c-.3-.6.2-1.3.9-1.5z",
  fill: "#f0d5a8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "unpinArtifactVersion_svg__d",
  d: "M39.3 41.5l7.6 7.9 6.2 22.9a1.284 1.284 0 01-.9 1.6l-30.3 8.2a1.284 1.284 0 01-1.6-.9l-6.2-23 2.6-10.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  stroke: "#191816",
  strokeLinejoin: "round",
  fill: "#fff",
  d: "M34.389 67.372l10.905-2.962 1.415 5.212-10.905 2.961z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "unpinArtifactVersion_svg__d",
  d: "M14 58.2l32.8-8.9M27.9 44.7l2.4 9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  fill: "#fff",
  d: "M65.1 34.7l-5.3 6.2-3.1 5.5 5-4 5.2-6-1.8-1.7z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M78.4 37.3c-2.9 3.4-8.8 3.1-13-.6-4.3-3.7-5.4-9.4-2.5-12.8s9.4-3.7 13.7 0c4.2 3.6 4.7 10 1.8 13.4z",
  fill: "#ab1aff",
  stroke: "#000"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#ab1aff",
  d: "M66.1 27.2L79.8 14l6.1 5.2-11.7 15.4-8.1-7.4z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "unpinArtifactVersion_svg__m",
  d: "M79.6 14.1L68.1 25.3M85.7 19.4l-9.8 13.1"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 83.525,
  cy: 15.275,
  rx: 5.8,
  ry: 8.5,
  transform: "rotate(-51.639 83.525 15.275)",
  fill: "#8d19e0",
  stroke: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 84.768,
  cy: 13.817,
  rx: 5.8,
  ry: 8.5,
  transform: "rotate(-51.639 84.768 13.817)",
  fill: "#b06cff",
  stroke: "#000"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "unpinArtifactVersion_svg__m",
  d: "M18.2 82.4a2.56 2.56 0 002.5 2M16.4 83.4a3.844 3.844 0 003.7 2.9M41.7 39.6a3.138 3.138 0 00-3.8-1"
});

function SvgUnpinArtifactVersion(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, React.createElement("ellipse", {
    cx: 48,
    cy: 79,
    rx: 25,
    ry: 1.9,
    style: {
      isolation: "isolate"
    },
    fill: "#191816",
    opacity: 0.15
  }), _ref3, _ref4, _ref5, _ref6, _ref7, React.createElement("path", {
    d: "M17.6 71.4l9.8-17.2-11.9 3.3a1.791 1.791 0 00-1.2 2.1z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff5e3",
    opacity: 0.7
  }), _ref8, _ref9, _ref10, React.createElement("path", {
    d: "M53.9 57.6s-.2.5-.4.3l3.6 4.1h2.8z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2,
    fill: "url(#unpinArtifactVersion_svg__a)"
  }), React.createElement("g", null, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, React.createElement("path", {
    d: "M80.5 20.5l-8.9 11.2-2.5 7.1s7.2 2.8 10.2-3a8.53 8.53 0 000-8.2l4.2-5.6 4.8-.1.7-1.1-5.4-1.2z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.3
  })), _ref17);
}

export default __webpack_public_path__ + "unpinArtifactVersion.8fe32.svg";
export { SvgUnpinArtifactVersion as ReactComponent };